import { jsx as _jsx } from "react/jsx-runtime";
import { CatLayoutContainer } from '@blocks-react/components/LayoutContainer';
export const SubheaderRow = ({ children }) => (_jsx(CatLayoutContainer, { children: _jsx("div", { className: "d-flex align-items-center", children: children }) }));
